import { getAllModulesInitActions, getSectionLayoutInitAction } from './common';

export function getHomeSectionInitActions(responseData) {
  const commentV2 =
    responseData.session.features &&
    responseData.session.features.includes('comment_v2');
  const params = { commentMaxDepth: commentV2 ? 4 : 3 };
  return [
    getSectionLayoutInitAction(responseData, 'home'),
    ...getAllModulesInitActions(responseData, params),
  ].filter(action => action);
}
